import TutorialProgress from '../api/tutorialProgress';
import { applicationApiExecute, applicationSave } from './applicationActions';

export const startTutorialProgress = applicationApiExecute(TutorialProgress.start);
export const completeTutorialProgress = applicationApiExecute(TutorialProgress.complete);
export const saveTutorialProgress = applicationSave(TutorialProgress);
